import {
    FETCH_ADD_ON,
    FETCH_ADD_ON_SUCCESS,
    FETCH_ADD_ON_FAILED,
    UPDATE_ADD_ON,
} from "../../store/types";

const initialState = {
    data: null,
};

export const addOnReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ADD_ON:
            console.log("📤 addOnReducer: FETCH_ADD_ON - Setting loading true");
            return {
                ...state,
                loading: true,
            };
        case FETCH_ADD_ON_SUCCESS:
            console.log(
                "✅ addOnReducer: FETCH_ADD_ON_SUCCESS - Data:",
                action.payload
            );
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case UPDATE_ADD_ON:
            console.log(
                "🔄 addOnReducer: UPDATE_ADD_ON - Data:",
                action.payload
            );
            return {
                ...state,
                data: action.payload,
            };
        case FETCH_ADD_ON_FAILED:
            console.log(
                "❌ addOnReducer: FETCH_ADD_ON_FAILED - Error:",
                action.payload
            );
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default addOnReducer;
